import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Sparkles } from 'lucide-react';

interface IcebreakerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  availableGems: number;
  targetUsername: string;
  isLoading?: boolean;
}

export const IcebreakerDialog: React.FC<IcebreakerDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  availableGems,
  targetUsername,
  isLoading = false
}) => {
  const hasEnoughGems = availableGems >= 1;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-gray-900 border-white/10 max-w-sm">
        <AlertDialogHeader>
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-luxury-pinkBright/20 flex items-center justify-center">
            <Sparkles className="w-8 h-8 text-luxury-pinkBright" />
          </div>
          <AlertDialogTitle className="text-white text-center">
            Gerar sugestões de quebra-gelo?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-white/60 text-center">
            A IA vai analisar o perfil de {targetUsername} e sugerir 3 mensagens personalizadas para começar a conversa.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="bg-white/5 rounded-lg p-3 my-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-white/60">Gemas disponíveis</span>
            <span className="text-luxury-pinkBright font-semibold">{availableGems} 💎</span>
          </div>
          <div className="flex items-center justify-between text-sm mt-1">
            <span className="text-white/60">Custo</span>
            <span className="text-white font-semibold">1 💎</span>
          </div>
          <div className="flex items-center justify-between text-sm mt-1 pt-1 border-t border-white/10">
            <span className="text-white/60">Após geração</span>
            <span className={`font-semibold ${hasEnoughGems ? 'text-white' : 'text-red-400'}`}>
              {Math.max(0, availableGems - 1)} 💎
            </span>
          </div>
        </div>

        {!hasEnoughGems && (
          <p className="text-red-400 text-sm text-center">
            Você não tem gemas suficientes. Ganhe gemas na Roleta da Sorte!
          </p>
        )}

        <AlertDialogFooter className="flex-col gap-2 sm:flex-col">
          <AlertDialogAction
            onClick={onConfirm}
            disabled={!hasEnoughGems || isLoading}
            className="w-full bg-gradient-to-r from-[#C4406B] to-[#9F3764] hover:opacity-90 text-white disabled:opacity-50"
          >
            {isLoading ? 'Gerando...' : 'Gerar Sugestões ✨'}
          </AlertDialogAction>
          <AlertDialogCancel className="w-full bg-white/5 border-white/10 text-white hover:bg-white/10">
            Cancelar
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
